import { sortByLastSeen, sortByStatus } from '@/features/pipelines/utils';
import type { ConnectableSource } from '..';

export function sortByLastSeenAndStatus(b: ConnectableSource, a: ConnectableSource) {
  const weight = 100;
  const byLastSeen = sortByLastSeen(a.status, b.status);
  const byStatus = sortByStatus(a.status, b.status);
  const byCompatibility = sortByCompatibility(a, b);
  return byCompatibility * weight * 2 - byLastSeen * weight - byStatus;
}

function sortByCompatibility(a: ConnectableSource, b: ConnectableSource) {
  if (a.isCompatible !== b.isCompatible) {
    return a.isCompatible ? -1 : 1;
  }
  return 0;
}
